import DOMPurify from 'dompurify'

import { normalizeOrgRichTextInput } from '~/utils/orgRichText'

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'del',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
  'h2',
  'h3',
] as const

const ALLOWED_ATTR = ['href', 'target', 'rel'] as const

/**
 * DOMPurify est only-client dans ce projet (pas de window côté SSR).
 */
export function sanitizeOrgRichText(rawHtml: string): string {
  if (typeof window === 'undefined' || !rawHtml) {
    return ''
  }
  const sanitized = DOMPurify.sanitize(rawHtml, {
    ALLOWED_TAGS: [...ALLOWED_TAGS],
    ALLOWED_ATTR: [...ALLOWED_ATTR],
    ALLOW_UNKNOWN_PROTOCOLS: false,
    FORBID_TAGS: ['style', 'svg', 'math', 'iframe', 'object', 'embed', 'script'],
    FORBID_ATTR: ['style', 'srcset', 'xlink:href', 'formaction', 'onclick'],
  })
  return String(sanitized)
}

export function toDisplayOrgRichHtml(value: string | null | undefined): string {
  if (typeof window === 'undefined') {
    return ''
  }
  const normalized = normalizeOrgRichTextInput(value ?? '')
  if (!normalized) {
    return ''
  }
  return sanitizeOrgRichText(normalized)
}
